import Modal from './Modal';
export { ModalPortal, ModalPortalDestination } from './ModalPortal';

export default Modal;
